import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const BookingChangeModelDetailsDesign = () => {
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const locationState = useLocation();
  const editUnqId = locationState.state?.unqid || null;
  const [Customername, setCustomername] = useState("");
  const isCustomerSelected = !!Customername;
  const [Model, setModel] = useState(null);
  const [Variant, setVariant] = useState(null);
  const [Color, setColor] = useState(null);
  const [Saleconsultant, setSaleconsultant] = useState("");
  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [NewModel, setNewModel] = useState("");
  const [NewVariant, setNewVariant] = useState("");
  const [NewColor, setNewColor] = useState("");
  const [NewewmodelOptions, setNewModelOptions] = useState([]);
  const [NewvariantOptions, setNewVariantOptions] = useState([]);
  const [NewcolorOptions, setNewColorOptions] = useState([]);
  const [Reason, setReason] = useState("");
  const [ReasonOptions, setReasonOptions] = useState([]);
  const [VinNo, setVinNo] = useState("");
  const [bookingDate, setBookingDate] = useState("");

  const customStyles = {
    control: (base) => ({ ...base, minHeight: "40px" }),
  };
  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  //--------------------HANDLE EXIT  WORKING----------------
  const handleExit = () => navigate("/VehicleAllocationGrid");
  //--------------------CUSTOMER NAME LIST WORKING----------------
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await apiFetch(
          "/api/vehicle/dropcust",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
          },
        );
        const data = await res.json();
        const options = data.map((item) => ({
          label: item.customername,
          value: item.rcl_11,
        }));
        setCustomerOptions(options);
      } catch (err) {
        console.error("Customer fetch error:", err);
      }
    };
    fetchCustomers();
  }, []);
  //--------------------WHEN CUSTOMER NAME SELECT THAN MODEL VARIANT COLOR FETCH WORKING----------------
  const fetchCustomerDetails = async (customerId) => {
    try {
      const res = await apiFetch(
        "/api/vehicle/modvarcolvin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ customerId }),
        },
      );
      const data = await res.json();
      if (data.length > 0) {
        const d = data[0];
        setModel({ label: d.model, value: d.model });
        setVariant({ label: d.variant, value: d.variant });
        setColor({ label: d.color, value: d.color });
      }
    } catch (err) {
      console.error("Error fetching details:", err);
    }
  };
  //--------------------FETCH MODELLIST WORKING----------------
  useEffect(() => {
    const fetchNewModels = async () => {
      const res = await apiFetch(
        "/api/vehicle/newmodel",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        },
      );
      const data = await res.json();
      const options = data.map((item) => ({
        label: item.model,
        value: item.unq,
      }));
      setNewModelOptions(options);
    };
    fetchNewModels();
  }, []);

  //--------------------FETCH VARIANT WORKING----------------
  const handleNewModelChange = async (selected) => {
    setNewModel(selected);
    setNewVariant(null);
    setNewColor(null);
    const res = await apiFetch(
      "/api/vehicle/newvariant",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ modelUnq: selected.value }),
      },
    );
    const data = await res.json();
    const options = data.map((item) => ({
      label: item.variant,
      value: item.unq,
    }));
    setNewVariantOptions(options);
  };

  //-------------------FETCH COLORLIST WORKING----------------
  const handleNewVariantChange = async (selected) => {
    setNewVariant(selected);
    setNewColor(null);
    const res = await apiFetch(
      "/api/vehicle/newcolor",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      },
    );
    const data = await res.json();
    const options = data.map((item) => ({
      label: item.color,
      value: item.unq,
    }));
    setNewColorOptions(options);
  };

  //-------------------FETCH REASON LISTWORKING----------------
  useEffect(() => {
    const fetchReasons = async () => {
      try {
        const res = await apiFetch(
          "/api/vehicle/reason",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          },
        );
        const data = await res.json();
        const options = data.map((item) => ({
          label: item.reason,
          value: item.unq,
        }));
        setReasonOptions(options);
      } catch (err) {
        console.error("Reason fetch error:", err);
      }
    };
    fetchReasons();
  }, []);

  //--------------------HANDLE SAVE WORKING----------------
  const handleSave = async () => {
    try {
      if (!Customername || !NewModel || !NewVariant || !NewColor || !Reason) {
        alert("Please fill all fields");
        return;
      }
      const payload = {
        sp_583: storedUserInfo?.userid || "",
        sp_584: ipAddress,
        sp_585: serverIp,
        sp_586: new Date().toISOString(),
        sp_587: new Date().toISOString(),
        sp_588: Customername,
        sp_589: "",
        sp_590: "",
        sp_591: Model?.value || "",
        sp_592: Variant?.value || "",
        sp_593: Color?.value || "",
        sp_594: VinNo || "",
        sp_595: NewModel?.value || "",
        sp_596: NewVariant?.value || "",
        sp_597: NewColor?.value || "",

        sp_598: new Date().toISOString(),
        sp_599: new Date().toISOString(),

        sp_600: Reason?.value || "",
      };
      console.log("FINAL PAYLOAD:", payload);
      const res = await apiFetch(
        "/api/vehicle/insert-change-model",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();

      if (data.err === "0") {
        alert("Saved Successfully ✅");
        navigate("/VehicleAllocationGrid");
      } else {
        alert(data.msg || "Error saving data");
      }
      navigate("/dashboard");
    } catch (err) {
      console.error("Save error:", err);
      alert("Something went wrong");
    }
  };
  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Booking Cancel</div>

          {/* FORM ROW 1 */}
          <div className="form-row">
            <div className="form-column">
              <label>Customer Name</label>
              <Select
                placeholder="Select Customer"
                options={customerOptions}
                value={
                  customerOptions.find((o) => o.value === Customername) || null
                }
                onChange={async (e) => {
                  const selectedId = e?.value;

                  setCustomername(selectedId);

                  if (selectedId) {
                    await fetchCustomerDetails(selectedId);
                  }
                }}
              />
            </div>
            <div className="form-column">
              <label>Model</label>
              <Select
                options={modelOptions}
                placeholder="Select Model"
                classNamePrefix="rs"
                styles={customStyles}
                value={Model}
                isDisabled={false}
                isClearable={false}
                isSearchable={false}
              />
            </div>
            <div className="form-column">
              <label>Variant</label>
              <Select
                options={variantOptions}
                value={Variant}
                isDisabled={false}
                isClearable={false}
                isSearchable={false}
              />
            </div>
            <div className="form-column">
              <label>Color</label>
              <Select
                options={colorOptions}
                value={Color}
                isDisabled={false}
                isClearable={false}
                isSearchable={false}
              />
            </div>
          </div>

          {/* FORM ROW 2 */}
          <div className="form-row">
            <div className="form-column">
              <label>New Model</label>
              <Select
                options={NewewmodelOptions}
                value={NewModel}
                onChange={handleNewModelChange}
              />
            </div>
            <div className="form-column">
              <label>New Variant</label>
              <Select
                options={NewvariantOptions}
                value={NewVariant}
                onChange={handleNewVariantChange}
                isDisabled={!NewModel}
              />
            </div>
            <div className="form-column">
              <label>New Color</label>
              <Select
                options={NewcolorOptions}
                value={NewColor}
                onChange={(e) => setNewColor(e)}
                isDisabled={!NewVariant}
              />
            </div>
            <div className="form-column">
              <label> Reason </label>
              <Select
                options={ReasonOptions}
                placeholder="Select Reason"
                value={Reason}
                onChange={(e) => setReason(e)}
              />
            </div>
          </div>

          {/* BUTTONS */}
          <div className="va-btn-container">
            <button className="va-btn-save" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>

      {/* 🔥 YOUR FULL STYLE SECTION STAYS EXACTLY AS IT IS BELOW */}

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
/* ================= PAGE ================= */

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1400px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,.1);
}

/* ================= HEADERS ================= */

.header,
.header1 {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================= FORM GRID ================= */

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}



.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

/* ================= INPUTS ================= */

input,
select {
  height: 40px !important;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  background: #fff;
}

input[type="date"] {
  padding-right: 35px;
}

/* ================= react-select FIX ================= */

.rs__control {
  min-height: 40px !important;
  height: 40px !important;
  border-radius: 5px !important;
}

.rs__value-container {
  height: 40px !important;
  padding: 0 10px !important;
  display: flex;
  align-items: center;
}

.rs__indicator {
  padding: 6px !important;
}

.rs__menu-portal {
  z-index: 9999 !important;
}

/* ================= RADIO ================= */

.company-auth {
  max-width: 220px;
}

.radio-group {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 8px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.radio-group input {
  width: 16px;
  height: 16px;
}

/* ================= TABLE ================= */

.table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  font-size: 13px;
}

th,
td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

thead tr {
  background: #f8bcbc;
}

.grid-input {
  width: 100%;
  height: 32px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

/* ================= BUTTONS ================= */

.va-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
  padding: 0 8px;
}

.va-btn-save,
.va-btn-exit {
  min-width: 120px;
  min-height: 44px;
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.2s;
  white-space: nowrap;
  box-sizing: border-box;
}

.va-btn-save {
  background: #4caf50;
  color: #fff;
}
.va-btn-save:hover { background: #43a047; }

.va-btn-exit {
  background: #ab2025;
  color: #fff;
}
.va-btn-exit:hover { background: #b02a37; }

.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.button-container button {
  min-width: 120px;
  min-height: 44px;
  padding: 12px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  border: none;
}

.btn-exit {
  background: #a20d0d;
  color: #fff;
  border: none;
}

.btn-edit {
  background: #2e20ab;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
}

/* ================= RESPONSIVE ================= */

/* Tablet */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .va-btn-container {
    flex-direction: column;
    align-items: stretch;
    padding: 0 16px;
  }

  .va-btn-save,
  .va-btn-exit {
    width: 100%;
    text-align: center;
    font-size: 15px;
    padding: 12px 16px;
  }

  .button-container button {
    flex: 1;
    width: 100%;
  }
}

/* Extra small */
@media (max-width: 400px) {
  .va-btn-save,
  .va-btn-exit {
    font-size: 14px;
    padding: 11px 12px;
  }
}

`}
      </style>
    </Layout>
  );
};

export default BookingChangeModelDetailsDesign;
